/**
 * GIỜ MẶT TRỜI cho ô "Mặt trời hôm nay" (GD-17 B4).
 *
 * ⛔ KHÔNG PHẢI CÔNG THỨC THỨ HAI. Máy chủ tính giờ mặt trời cho lịch ở
 *   `server/src/services/strategy.ts` → `sunTimesFor(lat, lng, date)` = `SunCalc.getTimes(date,
 *   lat, lng)` rồi `giờ*60 + phút` theo giờ địa phương. Ở đây là ĐÚNG lời gọi ấy, cùng thư viện
 *   `suncalc`, cùng phiên bản (`1.9.0`, ghim trong cả hai `package.json`). Không có endpoint nào
 *   trả giờ mặt trời cho một toạ độ tuỳ ý, và phiếu cấm thêm API ngoài ba trường chỉ đọc.
 *   `web/scripts/kiem_mattroi.ts` gọi CẢ HAI hàm (web + máy chủ) trên cùng toạ độ/ngày và đỏ nếu
 *   lệch > 1 phút — nên bản này không thể trôi khỏi máy chủ mà không ai biết.
 *
 * ⚠ Tệp này KHÔNG nhập React — bộ tự kiểm chạy nó bằng `tsx`.
 */
import SunCalc from 'suncalc';

/** Toạ độ mặc định khi chưa tủ nào có GPS: trung tâm TP.HCM (phiếu GD-17 B4). */
export const TOA_DO_MAC_DINH = { lat: 10.78, lng: 106.70 } as const;

export interface GioMatTroi {
  sunriseMin: number;
  sunsetMin: number;
}

/** Cùng hình dạng, cùng phép tính với `sunTimesFor()` của máy chủ. */
export function gioMatTroi(lat: number, lng: number, date: Date = new Date()): GioMatTroi {
  const t = SunCalc.getTimes(date, lat, lng);
  const toMin = (d: Date) => d.getHours() * 60 + d.getMinutes();
  return { sunriseMin: toMin(t.sunrise), sunsetMin: toMin(t.sunset) };
}

/** `HH:mm` từ phút trong ngày. */
export function phutRaGio(m: number): string {
  const p = (n: number) => String(n).padStart(2, '0');
  const x = ((Math.round(m) % 1440) + 1440) % 1440;
  return `${p(Math.floor(x / 60))}:${p(x % 60)}`;
}

/** Toạ độ trung bình các tủ CÓ định vị; không tủ nào ⇒ `null` (chỗ gọi dùng mặc định). */
export function toaDoTrungBinh(ds: { lat: number; lng: number }[]): { lat: number; lng: number } | null {
  if (ds.length === 0) return null;
  return {
    lat: ds.reduce((s, c) => s + c.lat, 0) / ds.length,
    lng: ds.reduce((s, c) => s + c.lng, 0) / ds.length,
  };
}
